// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".analytics-position-row[data-v-160438b1]{cursor:pointer;height:56%}.analytics-position-row>*[data-v-160438b1]{padding:10px}.mobile-only[data-v-160438b1]{display:none}.address[data-v-160438b1]{color:var(--main-green);-webkit-text-decoration:underline;text-decoration:underline}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
